/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  CredentialListService,
  ICredentialListMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  INotifyUserMethods,
  NotifyUserService,
  AnalyticeWidgetService,
  IAnalyticsWidgetMethods
} from './plugins';

export type CredentialListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  ICredentialListMethods &
  INotifyUserMethods & IAnalyticsWidgetMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new CredentialListService(),
    new NotifyUserService(),
    new AnalyticeWidgetService()
  ];
};

export const getAgent = () => {
  return createAgent<CredentialListPageAgent>({
    plugins: getPlugins(),
  });
};
